import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import Loadspinner from "../../../common/Loadspinner";
import Main from "../../../common/Main/Main";
import CommonService from "../../../services/CommonService";
import "./AskAnExpert.css";
import { Button, Snackbar } from "@material-ui/core";
import AskAnExpertService from "../../../services/AskAnExpertService";
import Alert from "@material-ui/lab/Alert";
import { logEvent } from "firebase/analytics";
import { analytics } from "../../../firebase";
import CommonConstants from "../../../constants/CommonConstants";

class AskAnExpert extends Component {
  constructor(props) {
    super(props);
    this.state = {
      system: true,
      divisionList: [],
      platformList: [],
      systemList: [],
      subSystemList: [],
      divisionId: 1,
      platformId: 0,
      systemId: 0,
      subSystemId: 0,
      isLoading: false,
      title: "",
      description: "",
      tags: [],
      attachment: null,
      success: false,
      fileName: "",
      type: "",
    };
  }

  componentDidMount() {
    this.getDivision();
    this.getPlatform();
    this.getSystem();
  }
  //division
  getDivision = async () => {
    this.setState({ isLoading: true });
    const res = await CommonService.getDivisionList();

    if (res) {
      this.setState({ divisionList: res });
    }
    this.setState({ isLoading: false });
  };

  setDivision = (e) => {
    this.getPlatform();
    this.getSystem();
    this.setState({ divisionId: e.target.value });
  };

  //platform

  getPlatform = async () => {
    let { divisionId } = this.state;
    this.setState({ isLoading: true });
    const res = await CommonService.getPlatformList(divisionId);

    if (res) {
      this.setState({ platformList: res });
    }
  };

  setPlatform = (e) => {
    this.setState({ platformId: e.target.value });
  };

  //system

  getSystem = async () => {
    let { divisionId } = this.state;
    const res = await CommonService.getSystemList(divisionId);

    if (res) {
      this.setState({ systemList: res });
    }
    this.setState({ isLoading: false });
  };

  setSystem = (e) => {
    this.setState({ systemId: e.target.value });
    if (e.target.value > 0) {
      this.setState({ system: false });
      this.getSubsystem(e.target.value);
    }
  };

  //subsystem

  getSubsystem = async (sysId) => {
    this.setState({ isLoading: true });
    const res = await CommonService.getSubSystemList(sysId);

    if (res) {
      let idList = res;
      idList.map((item) => (item.isSelected = false));
      this.setState({ subSystemList: idList });
    }
    this.setState({ isLoading: false });
  };
  setSubsystem = (e) => {
    this.setState({ subSystemId: e.target.value });
  };

  setUnchecked = (id) => {
    const subsystemLists = this.state.subSystemList;

    subsystemLists.map((item) =>
      item.id == id ? (item.isSelected = !item.isSelected) : null
    );
    this.setState({ subsystemList: subsystemLists });
  };

  //title

  setTitle = (e) => {
    this.setState({ title: e.target.value });
  };

  //description

  setDescription = (e) => {
    this.setState({ description: e.target.value });
  };

  //tags

  addTags = () => {
    let selectedIdList = [];

    this.state.subSystemList.map((item) =>
      item.isSelected ? selectedIdList.push(item.subsystem_desc) : null
    );

    this.setState({ tags: selectedIdList });
  };
  //attachment

  fileSelect = (e) => {
    this.setState({ attachment: e.target.files[0] });
    this.setState({ fileName: e.target.files[0].name });
    let type = e.target.files[0].type;
    let strarray = type.split("/");
    let strng = strarray[0];
    this.setState({ type: strng });
  };

  askaQuery = async (e) => {
    e.preventDefault();
    const {
      title,
      description,
      divisionId,
      platformId,
      systemId,
      subSystemId,
      attachment,
    } = this.state;

    const questionData = new FormData();

    questionData.append("title", title);
    questionData.append("description", description);
    // questionData.append("tag", tags);
    questionData.append("division_id", divisionId);
    questionData.append("platform_id", platformId);
    questionData.append("system_id", systemId);
    questionData.append("subsystem_id", subSystemId);
    questionData.append("attachment", attachment);
    questionData.append("video_id", "");
    questionData.append("transcription_data", "");
    questionData.append("thumbnailId", "");

    this.setState({ isLoading: true });
    const res = await AskAnExpertService.addQuery(questionData);
    if (res) {
      this.setState({ success: true });
      this.setState({ isLoading: false });

      // return (
      //   <Snackbar open={open} autoHideDuration={3000}>
      //     <Alert severity="success">{message}</Alert>
      //   </Snackbar>
      // );
    } else {
      this.setState({ isLoading: false });
      return (
        <Snackbar autoHideDuration={3000}>
          <Alert severity="error">Please try again</Alert>
        </Snackbar>
      );
    }
    //logEvent(analytics(), 'askAnExpert')
  };

  render() {
    const {
      system,
      divisionList,
      divisionId,
      platformList,
      systemList,
      subSystemList,
      isLoading,
      title,
      description,
      success,
      fileName,
      type,
    } = this.state;

    if (success) {
      return <Redirect to="/home" />;
    }

    return (
      <Main active="ask_an_expert">
        <Loadspinner filename="AskAnExpert.js" isLoading={isLoading} isMiddle="false" />
        <div className="container">
          <h5>Ask your query</h5>
          <div className="card create-knowledge-card">
            <div className="row card-row">
              <div className="col-6 ">
                <label
                  className="form-check-label"
                  style={{ marginRight: "20px" }}
                >
                  Division
                </label>
                {divisionList.map((division) => (
                  <div
                    className="form-check form-check-inline "
                    key={division.id}
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      value={division.id}
                      checked={divisionId == division.id ? true : false}
                      onChange={this.setDivision}
                      autoComplete={CommonConstants.autoCompleteInput}
                    />
                    <label className="form-check-label ">
                      {division.division_desc}
                    </label>
                  </div>
                ))}
              </div>
              <div className="col-6">
                <select
                  className="form-select"
                  required
                  onChange={this.setPlatform}
                >
                  <option value="" disabled selected>
                    Platform
                  </option>
                  {platformList.map((platform) => (
                    <option key={platform.id} value={platform.id}>
                      {platform.platform_desc}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="row card-row">
              <div className="col-6">
                <select
                  className="form-select"
                  required
                  onChange={this.setSystem}
                >
                  <option value="" disabled selected>
                    CoE
                  </option>
                  {systemList.map((system) => (
                    <option key={system.id} value={system.id}>
                      {system.system_desc}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-6">
                <select
                  className="form-select "
                  disabled={system}
                  required
                  onChange={this.setSubsystem}
                >
                  <option value="" disabled selected>
                    SubCoE
                  </option>
                  {subSystemList.map((subSystem) => (
                    <option key={subSystem.id} value={subSystem.id}>
                      {subSystem.subsystem_desc}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="row card-row">
              <div className="col-12">
                <textarea
                  className="form-control"
                  rows="2"
                  required
                  placeholder="Title"
                  onChange={this.setTitle}
                  value={title}
                />
              </div>
            </div>
            <div className="row card-row">
              <div className="col-12">
                <textarea
                  className="form-control"
                  rows="6"
                  required
                  placeholder="Detailed description"
                  onChange={this.setDescription}
                  value={description}
                />
              </div>
            </div>
            {/* <div className="row card-row display-row">
              <div className="col-2">
                <button
                  className="btn btn-primary"
                  disabled={system}
                  data-bs-toggle="modal"
                  data-bs-target="#addTagsqa"
                >
                  Add tags
                </button>
              </div>
              <div
                className="modal fade"
                id="addTagsqa"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                aria-labelledby="addExpertiseLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-sm">
                  <div
                    className="modal-content"
                    style={{ borderRadius: "10px" }}
                  >
                    <div className="modal-header">
                      <h5 className="modal-title ">Add tags</h5>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body">
                      {subSystemList.map((system) => (
                        <div key={system.id}>
                          <input
                            type="checkbox"
                            className="form-check-input popup-checkbox"
                            onChange={() => this.setUnchecked(system.id)}
                          />
                          <label className="form-check-label">
                            {system.subsystem_desc}
                          </label>
                        </div>
                      ))}
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-primary"
                        data-bs-dismiss="modal"
                        onClick={this.addTags}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-10 display-row">
                {tags.length > 0
                  ? tags.map((tag, index) => (
                      <div className="card" key={index}>
                        <small>{tag}</small>
                      </div>
                    ))
                  : null}
              </div>
            </div> */}
            <div className="row card-row">
              <div className="col-6">
                <input
                  style={{ display: "none" }}
                  id="contained-button-file"
                  type="file"
                  onChange={this.fileSelect}
                  accept="image/*,.xls,.xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel6k"
                  autoComplete={CommonConstants.autoCompleteInput}
                />
                <label
                  htmlFor="contained-button-file"
                  style={{ width: "100%" }}
                >
                  <Button
                    variant="contained"
                    style={{
                      width: "100%",
                      backgroundColor: "#198754",
                      color: "white",
                    }}
                    component="span"
                    onClick={this.fileUpload}
                  >
                    Upload
                  </Button>
                  <span>
                    {/* <img src={type} /> */}
                    {type}:
                  </span>
                  <span>{fileName}</span>
                </label>
              </div>
              <div className="col-3">
                <Link to="/home">
                  <button className="btn btn-danger" style={{ width: "100%" }}>
                    Cancel
                  </button>
                </Link>
              </div>
              <div className="col-3">
                <button
                  className="btn btn-danger"
                  style={{ width: "100%" }}
                  onClick={this.askaQuery}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </Main>
    );
  }
}

export default AskAnExpert;
